/**
 * Sistema de navegación por scroll horizontal UNIVERSAL para todas las tablas
 * Funciona automáticamente con cualquier tabla que tenga la estructura correcta
 * 
 * Estructura HTML requerida:
 * <div class="table-scroll-container" data-scrollable="false">
 *   <div class="table-scroll-nav">
 *     <button class="table-scroll-btn table-scroll-btn--left">‹</button>
 *     <span class="table-scroll-info">Información</span>
 *     <button class="table-scroll-btn table-scroll-btn--right">›</button>
 *   </div>
 *   <div class="table-scroll-wrapper">
 *     <table>...</table>
 *   </div>
 * </div>
 */

document.addEventListener('DOMContentLoaded', function() {
    
    // Sistema universal: busca automáticamente todos los contenedores
    initUniversalTableNavigation();
    
    // Mantener compatibilidad con implementaciones existentes
    initTableNavigation('.tab-style-eight__table-container', '.tab-style-eight__table-wrapper');
    initTableNavigation('.equivalence-table-container', '.equivalence-table');
    
    /**
     * Inicialización universal para cualquier tabla con la estructura estándar
     */
    function initUniversalTableNavigation() {
        const containers = document.querySelectorAll('.table-scroll-container');
        
        containers.forEach(container => {
            const scrollable = container.querySelector('.table-scroll-wrapper, table');
            const leftButton = container.querySelector('.table-scroll-btn--left');
            const rightButton = container.querySelector('.table-scroll-btn--right');
            const info = container.querySelector('.table-scroll-info');
            
            if (!scrollable || !leftButton || !rightButton) return;
            
            setupTableNavigation(container, scrollable, leftButton, rightButton, info);
        });
    }
    
    /**
     * Función para tablas específicas (compatibilidad hacia atrás)
     */
    function initTableNavigation(containerSelector, scrollableSelector) {
        const containers = document.querySelectorAll(containerSelector);
        
        containers.forEach(container => {
            const scrollable = container.querySelector(scrollableSelector);
            const leftButton = container.querySelector('#scroll-left, .table-nav-button--left');
            const rightButton = container.querySelector('#scroll-right, .table-nav-button--right');
            const info = container.querySelector('.tab-style-eight__table-nav-info, .equivalence-table__nav-info');
            
            if (!scrollable || !leftButton || !rightButton) return;
            
            setupTableNavigation(container, scrollable, leftButton, rightButton, info);
        });
    }
    
    /**
     * Configuración compartida para la navegación de tablas
     */
    function setupTableNavigation(container, scrollable, leftButton, rightButton, info) {
            
            // Verificar si hay overflow y mostrar controles
            function checkOverflow() {
                const hasOverflow = scrollable.scrollWidth > scrollable.clientWidth;
                
                if (hasOverflow) {
                    container.setAttribute('data-scrollable', 'true');
                    updateButtonStates();
                } else {
                    container.setAttribute('data-scrollable', 'false');
                }
            }
            
            // Actualizar estado de botones según posición actual
            function updateButtonStates() {
                const scrollLeft = scrollable.scrollLeft;
                const maxScroll = scrollable.scrollWidth - scrollable.clientWidth;
                
                // Botón izquierdo
                leftButton.disabled = scrollLeft <= 5;
                
                // Botón derecho
                rightButton.disabled = scrollLeft >= maxScroll - 5;
                
                // Actualizar info
                if (info) {
                    if (scrollLeft <= 5) {
                        info.textContent = 'Desliza hacia la derecha →';
                    } else if (scrollLeft >= maxScroll - 5) {
                        info.textContent = '← Desliza hacia la izquierda';
                    } else {
                        info.textContent = '← Desliza para navegar →';
                    }
                }
            }
            
            // Manejar click en botón izquierdo
            leftButton.addEventListener('click', () => {
                const scrollAmount = scrollable.clientWidth * 0.8;
                scrollable.scrollBy({
                    left: -scrollAmount,
                    behavior: 'smooth'
                });
            });
            
            // Manejar click en botón derecho
            rightButton.addEventListener('click', () => {
                const scrollAmount = scrollable.clientWidth * 0.8;
                scrollable.scrollBy({
                    left: scrollAmount,
                    behavior: 'smooth'
                });
            });
            
            // Escuchar eventos de scroll para actualizar botones
            scrollable.addEventListener('scroll', updateButtonStates);
            
            // Verificar overflow al cargar y redimensionar
            checkOverflow();
            window.addEventListener('resize', checkOverflow);
            
            // Verificar nuevamente después de que las imágenes se carguen
            setTimeout(checkOverflow, 500);
    }
});
